import React, { useEffect, useRef, useState } from "react";
import Banner from "../../../components/Banner";
import TicketListing from "../../../components/Home/TicketListing";
import WinningResults from "../../../components/Home/WinningResults";
import LatestWinners from "../../../components/Home/LatestWinners";
import SubFooter from "../../../components/SubFooter";
import Confetti from "../../../components/Confetti";
import styles from './index.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { selectUserDetails } from "../../../redux/features/auth/authSlice";
import { getNewWalletTransactions } from "../../../redux/features/wallet/walletServices";
import Gift from '../../../assets/images/icons/gift.png';
import { useTranslation } from "react-i18next";

const Home = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const [isOpen, setOpen] = useState(true);
    const [amount, setAmount] = useState(0);
    const modalRef = useRef(null);

    const { isLoggedIn } = useSelector(selectUserDetails);
    const { isTransactionsLoading, transactions } = useSelector((state) => state.wallet.walletTransactions);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        dispatch(getNewWalletTransactions());
    }, [dispatch]);

    return (
        <>
            <Banner />
            <TicketListing />
            <WinningResults />
            <LatestWinners />
            <SubFooter />
            {isOpen && isLoggedIn && transactions.length > 0 &&
                <>
                    <div className={styles.modal}>
                        <div className={styles.modalContainer} ref={modalRef}>
                            <Confetti />
                            <div className={styles.closeRow}>
                                <FontAwesomeIcon icon={faXmark} className={styles.xClass} size="2xl" onClick={() => {
                                    setOpen(false);
                                    document.body.style.overflow = 'unset';
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                }} />
                            </div>
                            <div className={styles.modalBody}>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <div className={styles.outerCircle}>
                                            <img src={Gift} className={`${styles.giftBox} ${styles.animate}`} alt="gift" />
                                        </div>
                                        <p className={styles.conText}>Congratulations!</p>
                                        <p className={styles.bodyText}>Cheers to your win! Rs. {transactions?.reduce((sum, item) => sum + item.amount, 0)} is coming your way!</p>
                                        <button className={styles.buyBtn} type="button"
                                            onClick={() => {
                                                setOpen(false);
                                                document.body.style.overflow = 'unset';
                                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                            }}
                                        >{t(`Continue`)}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>

    )
}

export default Home;